import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { createTaxRegion as universalCreateTaxRegion, deleteTaxRegion as universalDeleteTaxRegion, getTaxRegion as universalGetTaxRegion, queryTaxRegions as universalQueryTaxRegions, updateTaxRegion as universalUpdateTaxRegion, } from './billing-v1-tax-region-tax-regions.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function createTaxRegion(httpClient) {
    return (taxRegion) => universalCreateTaxRegion(taxRegion, 
    // @ts-ignore
    { httpClient });
}
export function getTaxRegion(httpClient) {
    return (taxRegionId) => universalGetTaxRegion(taxRegionId, 
    // @ts-ignore
    { httpClient });
}
export function updateTaxRegion(httpClient) {
    return (_id, taxRegion) => universalUpdateTaxRegion(_id, taxRegion, 
    // @ts-ignore
    { httpClient });
}
export function deleteTaxRegion(httpClient) {
    return (taxRegionId) => universalDeleteTaxRegion(taxRegionId, 
    // @ts-ignore
    { httpClient });
}
export function queryTaxRegions(httpClient) {
    return () => universalQueryTaxRegions(
    // @ts-ignore
    { httpClient });
}
export const onTaxRegionCreated = EventDefinition('wix.billing.v1.tax_region_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onTaxRegionDeleted = EventDefinition('wix.billing.v1.tax_region_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'undefined.createdDate' },
            { path: 'undefined.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onTaxRegionUpdated = EventDefinition('wix.billing.v1.tax_region_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export { SortOrder, WebhookIdentityType, } from './billing-v1-tax-region-tax-regions.universal.js';
//# sourceMappingURL=billing-v1-tax-region-tax-regions.public.js.map